import { useContext } from "react";
import { CurrencyContext } from "@/context/CurrencyContext";

export const useGlobalCurrency = () => {
	const context = useContext(CurrencyContext);
	if (context === undefined) {
		throw new Error("useGlobalCurrency must be used within a CurrencyProvider");
	}
	return context;
};
